export default [{ type: 1, label: 'gym' }, { type: 2, label: 'cafeteria' }, { type: 3, label: 'bigExpenses' }]